import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(CreateActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  return (initializeData: any = {}) => {
    setElement(initializeData);
    setShowModal(true);
    setTimeout(() => {
      setChanged(false, initializeData);
    }, 3000);
  };
}

export default useInitialize;
